import { PresetDefinition } from "../lib/types";

export const presets: Record<string, PresetDefinition> = {
  /** 红色标签 */
  redBadge: {
    entrance: "slideDown",
    position: "topCenter",
    theme: "#FF2222",
    backgroundColor: "#B40000",
    textColor: "#FF2222",
    fontSize: 34,
    fontWeight: 900,
    borderRadius: 16,
    border: "2px solid rgba(255, 60, 60, 0.6)",
    paddingX: 40,
    paddingY: 16,
    boxShadow: "0 0 30px rgba(255, 0, 0, 0.3)",
    textShadow: "0 0 20px rgba(255, 0, 0, 0.6)",
    delay: 10,
  },

  /** 蓝色标签 */
  blueTag: {
    entrance: "fadeIn",
    position: "topLeft",
    theme: "#40A9FF",
    backgroundColor: "#00336B",
    textColor: "#40A9FF",
    fontSize: 28,
    fontWeight: 700,
    borderRadius: 8,
    paddingX: 20,
    paddingY: 10,
    textShadow: "0 0 12px rgba(64, 169, 255, 0.5)",
    boxShadow: "0 0 16px rgba(0, 51, 107, 0.4)",
    delay: 5,
  },

  /** 绿色图章 */
  greenStamp: {
    entrance: "slideUp",
    position: "bottomRight",
    theme: "#4EFF4E",
    backgroundColor: "#0B3D0B",
    textColor: "#4EFF4E",
    fontSize: 30,
    fontWeight: 800,
    borderRadius: 12,
    border: "2px solid rgba(78, 255, 78, 0.4)",
    paddingX: 30,
    paddingY: 14,
    textShadow: "0 0 18px rgba(78, 255, 78, 0.5)",
    boxShadow: "0 0 20px rgba(11, 61, 11, 0.5)",
    delay: 15,
  },

  /** 半透明文字 — 无背景 */
  whiteGhost: {
    entrance: "fadeIn",
    position: "center",
    theme: "#ffffff",
    textColor: "rgba(255, 255, 255, 0.9)",
    fontSize: 24,
    fontWeight: 600,
    borderRadius: 8,
    paddingX: 24,
    paddingY: 12,
    textShadow: "0 0 30px rgba(255, 255, 255, 0.3)",
    delay: 20,
  },

  /** 黄色警告 */
  yellowWarning: {
    entrance: "slideDown",
    position: "topRight",
    theme: "#FFDD44",
    backgroundColor: "#CC8800",
    textColor: "#FFDD44",
    fontSize: 28,
    fontWeight: 700,
    borderRadius: 12,
    border: "2px solid rgba(255, 200, 0, 0.6)",
    paddingX: 30,
    paddingY: 14,
    textShadow: "0 0 15px rgba(255, 200, 0, 0.5)",
    boxShadow: "0 0 25px rgba(255, 150, 0, 0.3)",
    delay: 10,
  },
};
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
